import type { App, Plugin } from 'vue'

const RELOAD_FLAG = 'vite-preload-reload'

// Un onglet resté ouvert pendant un déploiement référence encore les anciens
// chunks hashés ; ceux-ci renvoient 404 → fallback SPA vers index.html (MIME
// refusé). Un seul reload force le rechargement du vrai index.html à jour.
const PreloadErrorReload: Plugin = {
  install(app: App) {
    window.addEventListener('vite:preloadError', () => {
      // Hors-ligne, recharger bouclerait.
      if (!navigator.onLine) return
      if (sessionStorage.getItem(RELOAD_FLAG)) return
      sessionStorage.setItem(RELOAD_FLAG, '1')
      window.location.reload()
    })

    app.mixin({
      mounted() {
        sessionStorage.removeItem(RELOAD_FLAG)
      }
    })
  }
}

export default PreloadErrorReload
